import React from "react";
import Card from "../Components/Card";
import CardList from "../Components/CardList";
import MainBg from "../Components/MainBg";
import "../Styles/Card.css";

function Home() {
  return (
    <div className="">
      {<MainBg />}
      {/* {<CardList />} */}
    </div>
  );
}

export default Home;
